// extracted by mini-css-extract-plugin
export default {"transactionTable":"TransactionTable_transactionTable__CvREQ","link":"TransactionTable_link__ZCX-g"};